/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentDeliveryOption
 */
export interface AppointmentDeliveryOption {
    /**
     * 
     * @type {string}
     * @memberof AppointmentDeliveryOption
     */
    type?: AppointmentDeliveryOptionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AppointmentDeliveryOption
     */
    telemedicine_method?: AppointmentDeliveryOptionTelemedicineMethodEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentDeliveryOption
     */
    only_subscribers?: boolean;
    /**
     * When true, the auto-booked follow-up appointment configured on the parent concern (`follow_up_concern`) is NOT created when an appointment is booked via this delivery option. Other delivery options on the same concern are unaffected. Resolved snapshot is persisted on the Appointment row at booking time for audit.
     * @type {boolean}
     * @memberof AppointmentDeliveryOption
     */
    skip_follow_up?: boolean;
    /**
     * When true, the patient-facing DeliveryOptionSelection screen skip-renders this option while preserving its ABSOLUTE position in `delivery_options` (surviving rows are NOT reindexed, so the stored `Appointment.delivery_option_index` stays stable). Staff dropdowns (EditAppointment, BookingConcernPicker) still show it with a "(hidden from patient)" suffix and can book it. This is intentionally a client-side soft filter — the server does NOT reject a patient submission that lands on a hidden index. Acceptable bypass risk for Care&'s non-adversarial patient population. Distinct from `AppointmentConcern.hidden_from_patient`, which IS server-enforced at the concern level (controllers/common/appointments.ts ~L1188 throws BadRequest when a patient books a hidden concern). Operational note: avoid reordering or deleting entries in `delivery_options` post-launch — `Appointment.delivery_option_index` is stored as an absolute position, so a reorder silently re-binds existing rows to whatever option now sits at that index. Append new options to the end.
     * @type {boolean}
     * @memberof AppointmentDeliveryOption
     */
    hidden_from_patient?: boolean;
}


/**
 * @export
 */
export const AppointmentDeliveryOptionTypeEnum = {
    Clinic: 'Clinic',
    Video: 'Video',
    Home: 'Home',
    Lab: 'Lab'
} as const;
export type AppointmentDeliveryOptionTypeEnum = typeof AppointmentDeliveryOptionTypeEnum[keyof typeof AppointmentDeliveryOptionTypeEnum];

/**
 * @export
 */
export const AppointmentDeliveryOptionTelemedicineMethodEnum = {
    Video: 'Video',
    Phone: 'Phone'
} as const;
export type AppointmentDeliveryOptionTelemedicineMethodEnum = typeof AppointmentDeliveryOptionTelemedicineMethodEnum[keyof typeof AppointmentDeliveryOptionTelemedicineMethodEnum];


/**
 * Check if a given object implements the AppointmentDeliveryOption interface.
 */
export function instanceOfAppointmentDeliveryOption(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AppointmentDeliveryOptionFromJSON(json: any): AppointmentDeliveryOption {
    return AppointmentDeliveryOptionFromJSONTyped(json, false);
}

export function AppointmentDeliveryOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentDeliveryOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'telemedicine_method': !exists(json, 'telemedicine_method') ? undefined : json['telemedicine_method'],
        'only_subscribers': !exists(json, 'only_subscribers') ? undefined : json['only_subscribers'],
        'skip_follow_up': !exists(json, 'skip_follow_up') ? undefined : json['skip_follow_up'],
        'hidden_from_patient': !exists(json, 'hidden_from_patient') ? undefined : json['hidden_from_patient'],
    };
}

export function AppointmentDeliveryOptionToJSON(value?: AppointmentDeliveryOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'telemedicine_method': value.telemedicine_method,
        'only_subscribers': value.only_subscribers,
        'skip_follow_up': value.skip_follow_up,
        'hidden_from_patient': value.hidden_from_patient,
    };
}

